import type { setAttachedCompanies } from 'Backend/users/utils/attachedCompanies/setAttachedCompanies';
import type { setCurrentCompanyId } from 'Lib/Utils';
import type { APICompany } from 'Models/models';

const USER_STATUS_LOCAL_STORAGE_KEY = 'PTUserStatus';
type Status = APICompany['status'];
/**
 * Convert string type to {@link Status}, leave other types as they are.
 *
 * Basically assert that if it's a string it's a Status string . Relatively safe type assertion.
 */
type StringToStatus<T> = T extends string ? Status : T;

export const getCompanyStatus = (): Status => {
    const storedValue = localStorage.getItem(USER_STATUS_LOCAL_STORAGE_KEY);
    return (storedValue as StringToStatus<typeof storedValue>) || 'PENDING'; // FIXME: I don't think we should just default to PENDING, something seems wrong if we don't have it. But can't deal with everything at once.
};

/**
 * Set company status.
 *
 * @deprecated // NOTE: You should probably not be using this directly. This changes as a side effect of {@link setCurrentCompanyId|changing company} or {@link setAttachedCompanies|updating attached companies}.
 *
 */
export const setCompanyStatus = (status: Status) => localStorage.setItem(USER_STATUS_LOCAL_STORAGE_KEY, status);
